import React, { useState, useContext } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
  required,
} from "../../../utils";
import { downloadPayrollCalendarEndDate } from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";

function PayrollCalendarEnddateContainer(props) {
  const [endDateFrom, setEndDateFrom] = useState(null);
  const [endDateTo, setEndDateTo] = useState(null);
  const formName = manageReportsFormNames.PAYROLL_CALENDAR_ENDDATE;
  const fields = formFields[formName];
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const exportReportFile = (payload) => {
    downloadPayrollCalendarEndDate(payload)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `PayrollCalendarEndDateReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  const onSubmit = (values) => {
    exportReportFile({
      EndDateFrom: values[fields.EndDateFrom],
      EndDateTo: values[fields.EndDateTo],
    });
  };

  return (
    <ManageReportLayout rptName="Payroll Calendar end date Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              endDateFrom: "",
              endDateTo: "",
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex mr-2">
                    <div className="d-flex mr-3 ml-3">
                      <Field
                        size="sm"
                        label="End date from  "
                        isRequired
                        name={fields.EndDateFrom}
                        value={usDateFormat(values[fields.EndDateFrom])}
                        direction="bottom"
                        isDatePicker
                        validate={(value) => {
                          return [undefined, null, ""].includes(value) ? (
                            "Required"
                          ) : value < values[fields.EndDateFrom] ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Should be ahead of "Pay date from"
                            </div>
                          ) : undefined;
                        }}
                        onClear={() => setFieldValue(fields.EndDateFrom, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.EndDateFrom, value)
                            }
                            value={usDateFormat(values[fields.EndDateFrom])}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3 SSN-style">
                        <Field
                          size="sm"
                          label="End date to "
                          isRequired
                          name={fields.EndDateTo}
                          value={usDateFormat(values[fields.EndDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.EndDateTo, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.EndDateTo, value)
                              }
                              value={usDateFormat(values[fields.EndDateTo])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              "Required"
                            ) : value < values[fields.EndDateFrom] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    {console.log("values", values)}
                    <div className="d-flex mr-3 ml-3"></div>
                    <Button
                      className="mt-12 sort-button button-css"
                      variant="secondary"
                      style={{ marginLeft: "8px", marginTop: "30px" }}
                      type="submit"
                    >
                      Request report
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
}

export default PayrollCalendarEnddateContainer;
